import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
function VolumeOffIcon(props, ref) {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "m3.5 3.5 4 4 .003-.003L8.917 8.91l-.003.003L10 10v-.006l2 2V12l2.122 2.121.002-.003 1.415 1.415-.003.003 1.414 1.414.003-.003 1.414 1.414-.003.003L20.5 20.5a1 1 0 0 1-1.414 1.414L12 14.828v3.758c0 .89-1.077 1.337-1.707.707L7 16H5a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h.172L2.086 4.914A1 1 0 0 1 3.5 3.5M7.172 10H5v4h2.828L10 16.17v-3.343zm7.824 2.162 1.661 1.66c.222-.564.343-1.18.343-1.822 0-1.38-.56-2.632-1.464-3.536a1 1 0 1 0-1.414 1.414 3 3 0 0 1 .874 2.284m3.164 3.165 1.462 1.46A8.96 8.96 0 0 0 21 12a8.98 8.98 0 0 0-2.636-6.364A1 1 0 0 0 16.95 7.05 6.98 6.98 0 0 1 19 12a7 7 0 0 1-.84 3.326M8.917 6.083 12 9.166V5.414c0-.89-1.077-1.337-1.707-.707z"
    })
  });
}
;
VolumeOffIcon.displayName = "VolumeOffIcon";
export default forwardRef(VolumeOffIcon);